import { render, staticRenderFns } from "./RepeaterItemMedia.vue?vue&type=template&id=98147b3c&"
import script from "./RepeaterItemMedia.vue?vue&type=script&lang=ts&"
export * from "./RepeaterItemMedia.vue?vue&type=script&lang=ts&"
import style0 from "./RepeaterItemMedia.vue?vue&type=style&index=0&id=98147b3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports